import type { Badge } from '@/shared/ui/badge'

export type LifecycleStatus =
  | 'retired'
  | 'discarded'
  | 'expired'
  | 'in_use'
  | 'opened'
  | 'received'
  | 'pending'

export const UNUSABLE_LIFECYCLE_STATUSES: readonly LifecycleStatus[] = [
  'expired',
  'retired',
  'discarded',
] as const

export const isUnusableLifecycleStatus = (
  lifecycleStatus: LifecycleStatus | null | undefined,
): boolean =>
  lifecycleStatus != null &&
  (UNUSABLE_LIFECYCLE_STATUSES as readonly string[]).includes(lifecycleStatus)

// Editing a lot detail is blocked only for a retired ("Retire Supply") lot — a discarded or
// expired lot stays editable (REBUILD-411). This is intentionally narrower than
// isUnusableLifecycleStatus (which also gates Select/Retire).
export const isEditBlockedLifecycleStatus = (
  lifecycleStatus: LifecycleStatus | null | undefined,
): boolean => lifecycleStatus === 'retired'

// REBUILD-394 / JW 399: each non-Expired/Discarded status gets a unique chip color.
// Expired + Discarded may share red (destructive). Received stays grey (outline).
export const LIFECYCLE_BADGE: Record<
  LifecycleStatus,
  React.ComponentProps<typeof Badge>['variant']
> = {
  received: 'outline',
  opened: 'success',
  pending: 'warning',
  in_use: 'default',
  retired: 'info',
  expired: 'destructive',
  discarded: 'destructive',
}
